import { useHistory } from "../utils";
import { KlydoGiftProps } from "../api/gift";

type NavigateDoneOverride = Partial<
  Pick<KlydoGiftProps, "orderName" | "clockId">
>;

export const useNavigateDone = () => {
  const { push } = useHistory();

  const navigateToDone = (searchParam: NavigateDoneOverride) => {
    const orderName = searchParam?.orderName;
    const clockId = searchParam?.clockId;

    const search = `orderName=${orderName ? orderName : clockId}`;

    push({
      pathname: "/gift/done",
      search,
    });
  };

  return navigateToDone;
};
